import React from 'react'
import { useTranslation } from 'react-i18next'

import { EnrolState, getTranslationEnrolStateKey } from 'enum'

interface FinalStateProps {
  state: EnrolState
  context?: 'male' | 'female'
}

export const FinalState: React.FC<FinalStateProps> = ({ state, context }) => {
  const { t } = useTranslation()
  const title = getTranslationEnrolStateKey(state)
  return <span>{t(`commons.enrols.finalStates.${title}`, { context })}</span>
}

export default FinalState
